import React from 'react';
import './loader.css';

interface LoaderProps {
  extraClasses?: string;
}

export const Loader: React.FC<LoaderProps> = ({ extraClasses = '' }) => (
  <div className={'loader ' + extraClasses}>Laster</div>
);
